import { useState } from 'react';
import type { HabitColor } from '../../shared/api';
import { stickerUrl } from '../lib/stickers';

interface Props {
  emoji: string;
  /** Shown instead of the emoji; the emoji stays as fallback when the image cannot load. */
  sticker?: string | null;
  color: HabitColor;
  size?: 'sm' | 'md' | 'lg';
}

/** The habit's sticker or emoji on a tile tinted with its color. */
export function EmojiTile({ emoji, sticker, color, size = 'md' }: Props) {
  const [failed, setFailed] = useState<string | null>(null);
  const showSticker = !!sticker && failed !== sticker;
  return (
    <span className={`emoji-tile emoji-tile--${size} hc-${color}${showSticker ? ' emoji-tile--sticker' : ''}`} aria-hidden="true">
      {showSticker ? (
        <img className="emoji-tile__sticker" src={stickerUrl(sticker)} alt="" decoding="async" draggable={false} onError={() => setFailed(sticker)} />
      ) : (
        <span className="emoji-tile__glyph">{emoji}</span>
      )}
    </span>
  );
}

/** Small inline version of the habit's symbol, e.g. in counters and stats. */
export function HabitGlyph({ emoji, sticker, className }: { emoji: string; sticker?: string | null; className?: string }) {
  const [failed, setFailed] = useState<string | null>(null);
  if (sticker && failed !== sticker) {
    return (
      <img className={`habit-glyph${className ? ` ${className}` : ''}`} src={stickerUrl(sticker)} alt="" decoding="async" draggable={false} onError={() => setFailed(sticker)} />
    );
  }
  return <span className={className}>{emoji}</span>;
}
